import script from "./SessionManagementPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionManagementPage.vue?vue&type=script&setup=true&lang=js"

import "./SessionManagementPage.vue?vue&type=style&index=0&id=0edbcf4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0edbcf4e"]])

export default __exports__